(function () {
  if (document.documentElement.dataset.mydFbtAddAllBound) return;
  document.documentElement.dataset.mydFbtAddAllBound = '1';

  function setButtonState(btn, state) {
    btn.dataset.originalLabel = btn.dataset.originalLabel || btn.textContent.trim();
    if (state === 'adding') {
      btn.disabled = true;
      btn.classList.add('is-adding');
      btn.textContent = 'Adding...';
    } else if (state === 'done') {
      btn.textContent = 'Added!';
      setTimeout(function () {
        btn.disabled = false;
        btn.classList.remove('is-adding');
        btn.textContent = btn.dataset.originalLabel;
      }, 1200);
    } else {
      btn.disabled = false;
      btn.classList.remove('is-adding');
      btn.textContent = btn.dataset.originalLabel;
    }
  }

  function modalFor(triggerBtn) {
    var wrap = triggerBtn.closest('.myd-fbt');
    if (!wrap) return null;
    return wrap.parentElement ? wrap.parentElement.querySelector('[data-myd-fbt-modal]') : null;
  }

  function resetModal(modal) {
    modal.querySelectorAll('.myd-fbt-modal__size-btn.is-selected').forEach(function (btn) {
      // Keep sole-value options (e.g. Free Size) pre-selected
      var group = btn.closest('[data-myd-fbt-option-group]');
      if (group && group.querySelectorAll('[data-myd-fbt-option-btn]').length === 1) return;
      btn.classList.remove('is-selected');
    });
    modal.querySelectorAll('[data-myd-fbt-modal-item]').forEach(function (item) {
      delete item.dataset.selectedVariantId;
      resolveMultiItem(item);
    });
    var hint = modal.querySelector('[data-myd-fbt-modal-hint]');
    if (hint) hint.hidden = true;
  }

  function parseVariants(itemEl) {
    var script = itemEl.querySelector('[data-myd-fbt-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function selectedOptionsForItem(itemEl) {
    var selected = [];
    itemEl.querySelectorAll('[data-myd-fbt-option-group]').forEach(function (group) {
      var index = Number(group.getAttribute('data-option-index'));
      var sel = group.querySelector('[data-myd-fbt-option-btn].is-selected');
      selected[index] = sel ? sel.getAttribute('data-value') : null;
    });
    return selected;
  }

  function resolveMultiItem(itemEl) {
    if (!itemEl || !itemEl.hasAttribute('data-myd-fbt-multi')) return;
    var variants = parseVariants(itemEl);
    var selected = selectedOptionsForItem(itemEl);
    var groups = itemEl.querySelectorAll('[data-myd-fbt-option-group]');
    if (!groups.length) return;

    var complete = selected.length >= groups.length && selected.every(function (v) {
      return v != null && v !== '';
    });

    var match = null;
    if (complete) {
      match = variants.find(function (v) {
        if (!v.available) return false;
        for (var i = 0; i < selected.length; i++) {
          if (v.options[i] !== selected[i]) return false;
        }
        return true;
      }) || null;
    }

    if (match) {
      itemEl.dataset.selectedVariantId = String(match.id);
    } else {
      delete itemEl.dataset.selectedVariantId;
    }

    // Disable option values that can't combine with current picks
    itemEl.querySelectorAll('[data-myd-fbt-option-btn]').forEach(function (btn) {
      if (btn.classList.contains('is-selected')) {
        btn.disabled = false;
        return;
      }
      var optIndex = Number(btn.getAttribute('data-option-index'));
      var value = btn.getAttribute('data-value');
      var ok = variants.some(function (v) {
        if (!v.available) return false;
        if (v.options[optIndex] !== value) return false;
        for (var i = 0; i < selected.length; i++) {
          if (i === optIndex) continue;
          if (selected[i] == null || selected[i] === '') continue;
          if (v.options[i] !== selected[i]) return false;
        }
        return true;
      });
      btn.disabled = !ok;
    });
  }

  function itemVariantId(itemEl) {
    if (!itemEl) return '';
    if (itemEl.dataset.selectedVariantId) return itemEl.dataset.selectedVariantId;
    var selected = itemEl.querySelector('.myd-fbt-modal__size-btn.is-selected[data-variant-id]');
    return selected ? selected.getAttribute('data-variant-id') : '';
  }

  // The modal renders deep inside the PDP's product-info markup. If any
  // ancestor there creates its own stacking context (transform, sticky
  // positioning, etc. — common on PDP info columns), this position:fixed
  // modal gets trapped inside it and later page sections (e.g. the
  // "Trusted by Millions" block) can render on top regardless of its own
  // z-index. Hoisting to <body> while open sidesteps that entirely — same
  // fix myd-search.js already uses for the quick-add sheet.
  function hoistToBody(modal) {
    if (modal.dataset.mydFbtHoisted) return;
    modal._homeParent = modal.parentElement;
    modal._homeNext = modal.nextSibling;
    document.body.appendChild(modal);
    modal.dataset.mydFbtHoisted = '1';
  }

  function restoreHome(modal) {
    if (!modal.dataset.mydFbtHoisted || !modal._homeParent) return;
    if (modal._homeNext && modal._homeNext.parentNode === modal._homeParent) {
      modal._homeParent.insertBefore(modal, modal._homeNext);
    } else {
      modal._homeParent.appendChild(modal);
    }
    delete modal.dataset.mydFbtHoisted;
  }

  function openModal(modal) {
    hoistToBody(modal);
    modal.querySelectorAll('[data-myd-fbt-modal-item][data-myd-fbt-multi]').forEach(resolveMultiItem);
    modal.hidden = false;
    // hidden -> visible has to land on one frame before the "is-open"
    // class is added, otherwise the panel jumps straight to translateY(0)
    // instead of sliding up from the bottom.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
      });
    });
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    setTimeout(function () {
      modal.hidden = true;
      resetModal(modal);
      restoreHome(modal);
    }, 320);
  }

  document.addEventListener('click', function (event) {
    var addAllBtn = event.target.closest('[data-myd-fbt-add-all]');
    if (addAllBtn) {
      var modal = modalFor(addAllBtn);
      if (modal) {
        event.preventDefault();
        openModal(modal);
      }
      return;
    }

    var closeTrigger = event.target.closest('[data-myd-fbt-modal-close]');
    if (closeTrigger) {
      var modalToClose = closeTrigger.closest('[data-myd-fbt-modal]');
      if (modalToClose) {
        event.preventDefault();
        closeModal(modalToClose);
      }
      return;
    }

    var optionBtn = event.target.closest('[data-myd-fbt-option-btn]');
    if (optionBtn) {
      event.preventDefault();
      if (optionBtn.disabled) return;
      var optionGroup = optionBtn.closest('[data-myd-fbt-option-group]');
      var multiItem = optionBtn.closest('[data-myd-fbt-modal-item]');
      var multiModal = optionBtn.closest('[data-myd-fbt-modal]');
      if (optionGroup) {
        optionGroup.querySelectorAll('[data-myd-fbt-option-btn].is-selected').forEach(function (btn) {
          btn.classList.remove('is-selected');
        });
      }
      optionBtn.classList.add('is-selected');
      resolveMultiItem(multiItem);
      if (multiModal) {
        var multiHint = multiModal.querySelector('[data-myd-fbt-modal-hint]');
        if (multiHint) multiHint.hidden = true;
      }
      return;
    }

    var sizeBtn = event.target.closest('[data-myd-fbt-size-btn]');
    if (sizeBtn) {
      event.preventDefault();
      if (sizeBtn.disabled) return;
      var item = sizeBtn.closest('[data-myd-fbt-modal-item]');
      var modalRoot = sizeBtn.closest('[data-myd-fbt-modal]');
      var wasSelected = sizeBtn.classList.contains('is-selected');
      if (item) {
        item.querySelectorAll('[data-myd-fbt-size-btn].is-selected').forEach(function (btn) {
          btn.classList.remove('is-selected');
        });
      }
      if (!wasSelected) sizeBtn.classList.add('is-selected');
      if (modalRoot) {
        var hint = modalRoot.querySelector('[data-myd-fbt-modal-hint]');
        if (hint) hint.hidden = true;
      }
      return;
    }

    var confirmBtn = event.target.closest('[data-myd-fbt-modal-confirm]');
    if (confirmBtn) {
      event.preventDefault();
      if (confirmBtn.disabled) return;
      var confirmModal = confirmBtn.closest('[data-myd-fbt-modal]');
      if (!confirmModal) return;

      var items = [];
      confirmModal.querySelectorAll('[data-myd-fbt-modal-item]').forEach(function (itemEl) {
        var variantId = itemVariantId(itemEl);
        if (variantId) items.push({ id: variantId, quantity: 1 });
      });

      if (!items.length) {
        var hintEl = confirmModal.querySelector('[data-myd-fbt-modal-hint]');
        if (hintEl) {
          hintEl.textContent = 'Select all options for at least one product to continue.';
          hintEl.hidden = false;
        }
        return;
      }

      confirmBtn.disabled = true;
      confirmBtn.dataset.originalLabel = confirmBtn.dataset.originalLabel || confirmBtn.textContent.trim();
      confirmBtn.textContent = 'Adding...';

      var addAllTrigger = document
        .querySelectorAll('[data-myd-fbt-add-all]');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return response.json();
        })
        .then(function () {
          return typeof window.MYDCartRefresh === 'function'
            ? window.MYDCartRefresh()
            : Promise.resolve();
        })
        .then(function () {
          closeModal(confirmModal);
          confirmBtn.disabled = false;
          confirmBtn.textContent = confirmBtn.dataset.originalLabel;
          addAllTrigger.forEach(function (btn) {
            setButtonState(btn, 'done');
          });
          var mini = document.querySelector('mini-cart');
          if (mini && typeof mini.open === 'function') {
            requestAnimationFrame(function () {
              mini.open();
            });
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'myd-fbt-add-all' } }));
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
        })
        .catch(function () {
          alert('Could not add these items to cart. Please try again.');
          confirmBtn.disabled = false;
          confirmBtn.textContent = confirmBtn.dataset.originalLabel;
        });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var openModalEl = document.querySelector('[data-myd-fbt-modal]:not([hidden])');
    if (openModalEl) closeModal(openModalEl);
  });

  // Scroll-position dots — same active-tracking approach as the quick-add
  // sheet's image gallery dots (myd-search.js syncDots), pointed at the
  // FBT card row instead of the gallery.
  document.querySelectorAll('[data-myd-fbt-scroller]').forEach(function (scroller) {
    var wrap = scroller.closest('.myd-fbt');
    var dotsEl = wrap ? wrap.querySelector('[data-myd-fbt-dots]') : null;
    if (!dotsEl) return;

    function syncDots() {
      var cards = scroller.querySelectorAll('.myd-fbt__card');
      if (!cards.length) return;
      var gap = parseFloat(getComputedStyle(scroller).columnGap || getComputedStyle(scroller).gap || '0') || 0;
      var step = cards[0].offsetWidth + gap;
      if (!step) return;
      var index = Math.min(cards.length - 1, Math.max(0, Math.round(scroller.scrollLeft / step)));
      dotsEl.querySelectorAll('span').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    scroller.addEventListener('scroll', syncDots, { passive: true });
  });
})();
